import { axios } from '@/utils/request'

export function sendRegistration (parameter) {
    return axios({
        url: '/program-registration/',
        method: 'post',
        data: parameter
    })
}
